import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { MessageCircle, Loader2, BellRing } from "lucide-react";
import { Input } from "@/components/ui/input";
import { useLang } from "@/i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function SubscribeStrip() {
  const { str } = useLang();
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const digits = phone.replace(/\D/g, "");
    if (digits.length < 10) return toast.error(str.subPhoneErr);
    setBusy(true);
    try {
      const res = await axios.post(`${API}/subscribe`, { name, phone: digits });
      toast.success(res.data.already ? str.subAlready : str.subOk);
      setName("");
      setPhone("");
    } catch {
      toast.error(str.subErr);
    } finally {
      setBusy(false);
    }
  };

  return (
    <section data-testid="subscribe-strip" className="border-y border-white/10 bg-[#0F0F0F] px-6 sm:px-10 lg:px-16 py-14">
      <div className="flex flex-col lg:flex-row lg:items-center gap-8 lg:gap-14">
        <div className="flex items-start gap-4 lg:max-w-md">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center bg-[#25D366]/15 text-[#25D366]">
            <BellRing size={18} />
          </span>
          <div>
            <p className="font-display font-extrabold uppercase tracking-tight text-lg text-[#FDFDFD]">{str.subH1}</p>
            <p className="text-sm text-white/50 mt-1.5 leading-relaxed">{str.subPara}</p>
          </div>
        </div>
        <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3 flex-1" data-testid="subscribe-form">
          <Input
            data-testid="subscribe-name-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder={str.namePh}
            className="rounded-none border-white/15 bg-[#121212] text-[#FDFDFD] font-ticker h-12 sm:max-w-[220px]"
          />
          <Input
            data-testid="subscribe-phone-input"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder={str.mobilePh}
            inputMode="numeric"
            className="rounded-none border-white/15 bg-[#121212] text-[#FDFDFD] font-ticker h-12 sm:max-w-[220px]"
          />
          <button
            type="submit"
            disabled={busy}
            data-testid="subscribe-submit-btn"
            className="inline-flex h-12 items-center justify-center gap-2 bg-[#25D366] px-8 font-ticker text-[11px] tracking-[0.2em] uppercase font-semibold text-[#0A0A0A] hover:bg-[#7BE3A6] transition-colors disabled:opacity-60 whitespace-nowrap"
          >
            {busy ? <Loader2 size={14} className="animate-spin" /> : <MessageCircle size={14} />} {str.subBtn}
          </button>
        </form>
      </div>
    </section>
  );
}
